import React, { useEffect } from "react";
import { IonLabel } from "@ionic/react";
import { WORKFLOW_WERKER_TYPES } from "../functions/postActionTypes";
import "../theme/AppStyles.css";


export const JobStatsSummary: React.FC<any> = ({ jobsDocs }: { jobsDocs: any[] }) => {
  
  // console.log("JobStatsSummary");
 
  const [jobDocCounts, setJobDocCounts] = React.useState<any>({});

  useEffect(() => {
    // You can perform any side effects here if needed when jobsDocs change
    const counts = {
      past: 0,
      scheduled: 0,
      invited: 0,
      expired: 0,
      cancelled: 0,
      uncategorized: 0,
    };

    jobsDocs.forEach((job: any) => {
      // Skip if scheduler (userInfoFrom === userInfoTo)
      if (job.docStamp?.userInfoFrom?.uid === job.docStamp?.userInfoTo?.uid) {
        return;
      }

      const jobStatusWerker = job.jobInfo?.status?.jobStatusWerker;

      // Categorize based on status
      if (jobStatusWerker === WORKFLOW_WERKER_TYPES.Past) {
        counts.past++;
      } else if (jobStatusWerker === WORKFLOW_WERKER_TYPES.Scheduled) {
        counts.scheduled++;
      } else if (jobStatusWerker === WORKFLOW_WERKER_TYPES.Invited) {
        counts.invited++;
      } else if (jobStatusWerker === WORKFLOW_WERKER_TYPES.Expired) {
        counts.expired++;
      } else if (jobStatusWerker === WORKFLOW_WERKER_TYPES.Cancelled) {
        counts.cancelled++;
      } else {
        counts.uncategorized++;
      }
    });
    setJobDocCounts(counts);
  }, [jobsDocs]);

  return (
    <React.Fragment>
      <IonLabel className="labelo">
        <h2>Job Stats Summary</h2>
        <h3>Werker Counts</h3>
        <h4>Past: {jobDocCounts.past}</h4>
        <h4>Scheduled: {jobDocCounts.scheduled}</h4>
        <h4>Invited: {jobDocCounts.invited}</h4>
        <h4>Expired: {jobDocCounts.expired}</h4>
        <h4>Cancelled: {jobDocCounts.cancelled}</h4>
        <h4>Uncategorized: {jobDocCounts.uncategorized}</h4>
      <br></br>
    </IonLabel>
    </React.Fragment>
  );
}
